import * as REAL from "real_api";

export default class R3DExporter {
    constructor() {
    }
    async export(scene, onProgress, onError) {
        return await REAL.Scene(scene, undefined, onProgress, onError);
    }
}
